import React from 'react';
import './AdminNavigation.css';

const AdminNavigation = ({ activeTab, setActiveTab, hasPermission, userRoles = [], pendingUsersCount = 0 }) => {

    const allTabs = [
        { id: 'pending-users', name: 'Ausstehende Benutzer', icon: '⏳', category: 'users', description: 'Benutzer freischalten oder ablehnen', permission: null },
        { id: 'dashboard', name: 'Dashboard', icon: '📊', category: 'dashboard', description: 'Dashboard und Team-Übersicht', permission: 'view_dashboard' },
        { id: 'users', name: 'Benutzer', icon: '👥', category: 'users', description: 'Benutzer und Profile verwalten', permission: 'view_users' },
        { id: 'category-permissions', name: 'Berechtigungen', icon: '🔐', category: 'permissions', description: 'Kategorie-Berechtigungen verwalten', permission: 'manage_permissions' },
        { id: 'panel-settings', name: 'Panel Settings', icon: '⚙️', category: 'settings', description: 'Rollen, Channels & Bot-Konfiguration', permission: 'admin_access' },
    ];

    const tabs = allTabs.filter(tab => {
        if (userRoles.length > 0) {
            return true;
        }
        if (!tab.permission) return false;
        if (typeof hasPermission !== 'function') return false;
        return hasPermission(tab.permission);
    });

    const noTabsAvailable = tabs.length === 0;

    return (
        <div className="admin-navigation">
            <div className="nav-header">
                <h3>Administration</h3>
            </div>
            <div className="nav-tabs" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
                {noTabsAvailable ? (
                    <div style={{ padding: '12px 16px', color: '#bbb' }}>⚠️ Keine Berechtigungen für das Admin Panel</div>
                ) : (
                    tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
                        >
                            <span className="tab-icon">{tab.icon}</span>
                            <span className="tab-name">{tab.name}</span>
                            {tab.id === 'pending-users' && pendingUsersCount > 0 && (
                                <span className="badge badge-warning" style={{ marginLeft: '8px' }}>
                                    {pendingUsersCount}
                                </span>
                            )}
                        </button>
                    ))
                )}
            </div>
        </div>
    );
};

export default AdminNavigation;
